import { Box, Divider, Typography } from "@mui/material";
import pagckgebackground from "../../Assets/2-way-lane.jpg";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import { fontFamilyAll } from "../../Util/UtilColor";
import { packageData } from "../../Assets/data";

export default function BussinessPackage() {
  const Styles = {
    packageStyle: {
      backgroundColor: "rgba(255,0,0,0.8)", // semi-transparent red
      borderRadius: "20px",
      fontFamily:fontFamilyAll,
      position: "relative",
      padding: "20px",
      minHeight: "75vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        borderRadius: "20px",
        zIndex: 1,
      },
      "& > *": {
        position: "relative",
        zIndex: 2,
      },
    },
    packageHeading: {
      color: "white",
      fontFamily: fontFamilyAll,
      fontSize: { xs: "20px", sm: "24px", md: "28px", lg: "30px" },
      fontWeight: "600",
      margin: "20px 0",
      textAlign: "center",
    },
    packagePrice: {
      color: "white",
      fontFamily: fontFamilyAll,
      fontSize: { xs: "40px", sm: "50px", md: "60px" },
      fontWeight: "600",
      margin: "20px 0",
      textAlign: "center",
    },
    packageFeatureText: {
      marginLeft: "10px",
      color: "black",
      fontFamily: fontFamilyAll,
      fontSize: { xs: "16px", sm: "18px", md: "20px" },
      fontWeight: "500",
    },
    packgeFeatureContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      margin: "15px 0",
    },
    iconBox: {
      width: "35px", // fixed width for icons
      display: "flex",
      justifyContent: "center",
    },
    dividerStyle: {
      margin: "0px 20px",
      borderBottomWidth: "1px",
      borderColor: "rgba(125, 123, 123, 0.74)",
    },
  };


  const icons = [
    <LocalShippingOutlinedIcon sx={{ color: "black", fontSize: "25px" }} />,
    <AddBoxOutlinedIcon sx={{ color: "black", fontSize: "25px" }} />,
    <AttachMoneyOutlinedIcon sx={{ color: "black", fontSize: "25px" }} />,
    <SpeedOutlinedIcon sx={{ color: "black", fontSize: "25px" }} />,
  ];

  return (
    <Box
      sx={{
        backgroundImage: `url(${pagckgebackground})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        py: { xs: 6, sm: 8, md: 10 },
        px: { xs: 2, sm: 4, md: 10, lg: 15 },
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr", // mobile → 1 per row
          sm: "1fr 1fr", // tablet → 2 per row
          lg: "1fr 1fr 1fr", // desktop → 3 per row
        },
        gap: 3,
      }}
    >
      {packageData.map((pkg, i) => (
        <Box key={i} sx={Styles.packageStyle}>
          <Typography sx={Styles.packageHeading}>{pkg.title}</Typography>
          <Typography sx={Styles.packagePrice}>
            <sup style={{ fontSize: "24px", fontWeight: "500" }}>$</sup>
            {pkg.price}
            <sub style={{ fontSize: "18px", fontWeight: "500" }}>/ month</sub>
          </Typography>
          <Divider sx={Styles.dividerStyle} />

          {pkg.features.map((feature, idx) => (
            <Box key={idx}>
              <div style={Styles.packgeFeatureContainer}>
                <Box sx={Styles.iconBox}>{icons[idx]}</Box>
                <Typography sx={Styles.packageFeatureText}>{feature}</Typography>
              </div>
              {idx < pkg.features.length - 1 && <Divider sx={Styles.dividerStyle} />}
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}
